import $ from 'jquery';



/* Finishes toggle
********************************************/

if ($('.js-finish-toggles').length) {
	$('.js-finish-toggles a').on('click', function (e) {
		e.preventDefault();
		var $this = $(this);
		var layoutID = $this.attr('data-finish');

		if ( !$this.parent().hasClass( 'is-selected' ) ) {
			$this.parent().toggleClass('is-selected');
			$this.parent().siblings().removeClass('is-selected');
			$this.closest('.js-finish-toggles').removeClass (function (index, className) {
				return (className.match (/(^|\s)has-selected-\S+/g) || []).join(' ');
			}).addClass('has-selected-' + layoutID + '')
		}
	});
}
